/** Shared supervisor confirmation and login flow for connecting to an account. */
import { useState } from "react"
import { useTranslation } from "react-i18next"
import Modal from "@/components/modal"
import Chip from "@/components/chip"
import LoginModal from "@/modals/login.modal"
import { ACCOUNT_DEMO, ACCOUNT_DEMO_COLOR, Account } from "@/redux/account.types"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { sessionEdit } from "@/redux/_session.actions"

interface Props {
  account: Pick<Account, "id" | "name">
  onClose: () => void
}

export default function SupervisorAccountConnectModal({ account, onClose }: Props) {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const session = useAppSelector((state) => state._session)
  const [isLoggingIn, setIsLoggingIn] = useState(false)

  if (isLoggingIn) {
    return <LoginModal authLevel={2} isSupervisor accountIdForSuperadmin={account.id} email={session.email} onClose={onClose} />
  }

  return (
    <Modal isCloseButtonVisible onClose={onClose} onNext={() => setIsLoggingIn(true)}>
      <p>{t("account_connect")} : <b>{account.name}</b></p>
      {account.id === ACCOUNT_DEMO.id && (
        <>
          <p className="grey-t">{"Enquête à faire afficher sur l'écran d'accueil"}</p>
          <div className="flex">
            {(["qvt", "rps"] as const).map((survey) => (
              <Chip
                key={survey}
                color={session.accountDemoSurvey === survey ? ACCOUNT_DEMO_COLOR : undefined}
                isWithMargin
                onClick={() => dispatch(sessionEdit("accountDemoSurvey", survey))}>
                {survey.toUpperCase()}
              </Chip>
            ))}
          </div>
        </>
      )}
    </Modal>
  )
}
